document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.wp-block-acf-equipment-tabs');

  sections.forEach(section => {
    const tabs = section.querySelectorAll('.equipment-details_tabs__tab');
    const contents = section.querySelectorAll('.equipment-details_content__wrapper');

    function activateTab(index) {
      tabs.forEach((tab, i) => {
        if (i === index) {
          tab.classList.add('active');
          contents[i].style.display = 'flex';
        } else {
          tab.classList.remove('active');
          contents[i].style.display = 'none';
        }
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(index);
      });
    });

    activateTab(0);
  });
});
